import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { isNil } from "lodash";

const ONE_MILLION = 1000000;

/**
 * The raw data, which is 50,000 should be formatted in the following form 0.05M
 * with the following steps:
 * - divided by 1,000,000
 * - presented in 2 decimal places
 * - have the letter "M" after the last digit
 */
class AbbreviatedMillionNumberFormat extends Component {
  render() {
    let value = this.props.value;
    const prefix = this.props.prefix || "";
    const negativeClass = this.props.negativeClass || "";
    const className = value < 0 ? negativeClass : "";
    const suffix = this.props.suffix || "";
    const forceConvert = this.props.forceConvert || false;
    const hideZero = this.props.hideZero || false;
    const decimalPrecision = isNil(this.props.decimalPrecision)
      ? 0
      : this.props.decimalPrecision;
    const addSpaceBeforeSuffix = this.props.addSpaceBeforeSuffix || false;
    const space = addSpaceBeforeSuffix ? " " : "";
    const floatCount = this.props.floatCount || 3;

    if (
      value >= ONE_MILLION ||
      value <= ONE_MILLION * -1 ||
      forceConvert === true
    ) {
      const negative = value < 0 ? "-" : "";
      value = (Math.abs(value) / ONE_MILLION).toFixed(floatCount);

      if (hideZero === true && Number(value) === 0) {
        return <span>&nbsp;</span>;
      }

      return (
        <span
          className={className}
        >{`${negative}${prefix}${value}${space}M${suffix}`}</span>
      );
    }

    if (hideZero === true && value === 0) {
      return <span>&nbsp;</span>;
    }

    return (
      <span className={className}>
        <NumberFormat
          value={value}
          prefix={prefix}
          suffix={suffix}
          displayType="text"
          thousandSeparator=","
          decimalPrecision={decimalPrecision}
        />
      </span>
    );
  }
}

export default AbbreviatedMillionNumberFormat;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/numbers/AbbreviatedMillionNumberFormat.js